import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'
import { connect } from 'react-redux'
import { selectBusinessTravellerCurrentApprovalRequest } from 'businessTraveller/selectors/selectBusinessTravellerCurrentApprovalRequest'

interface Props {
  /**
   * The percentage the budget/approval is exceeded by.
   */
  exceedingPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
  currentApprovalRequest?: App.BusinessTraveller.ApprovalRequest
  /**
   * Overrides the label. When provided, uses this instead of inferring from approverId.
   * Use 'approval' when comparing to trip request approved amount, 'budget' when comparing to company policy budget.
   */
  labelVariant?: 'approval' | 'budget'
}

function PriceRowBusinessTravellerExceededBudget(props: Props) {
  const {
    exceedingPercentage,
    onClick,
    currentApprovalRequest,
    labelVariant,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  const useApprovalLabel = labelVariant === 'approval' || (labelVariant === undefined && currentApprovalRequest?.approverId)

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="pending" endIcon={<LineInfoCircleIcon />}>
      {useApprovalLabel ? `Exceeds approved by ${exceedingPercentage}%` : `Exceeds budget by ${exceedingPercentage}%`}
    </StatusLabel>
  </Clickable>
}

const mapStateToProps = (state: App.State) => ({
  currentApprovalRequest: selectBusinessTravellerCurrentApprovalRequest(state),
})

export default connect(mapStateToProps)(PriceRowBusinessTravellerExceededBudget)
